import { clearGlbUrlCache } from '@utils/sceneObjects/glbLoaderCache'
import { disposeGlbSource } from '@utils/sceneObjects/disposeGlbClone'
import { evictUnreferencedTextures } from '@utils/sceneObjects/loadedTextureCache'
import { clearObjectMeshTextureCache } from '@utils/sceneObjects/objectMeshTextureCache'
import { isLightweightViewer } from '../../viewport/readCapabilities'
import type { Object3D } from 'three'

type SceneGlbEntry = { glb?: { scene?: Object3D } | Object3D }

function rootFromEntry(entry: SceneGlbEntry | undefined): Object3D | null {
  const glb = entry?.glb
  if (!glb) return null
  if ((glb as { scene?: Object3D }).scene) return (glb as { scene: Object3D }).scene
  return glb as Object3D
}

/**
 * Phone/tablet only. Desktop keeps session caches.
 * Call after the previous project's meshes have unmounted.
 */
export function releasePreviousPlannerGlbs(previous: Iterable<SceneGlbEntry>) {
  if (!isLightweightViewer()) return

  for (const entry of previous) {
    const root = rootFromEntry(entry)
    if (!root) continue
    try {
      disposeGlbSource(root)
    } catch {
      // already disposed
    }
  }

  clearGlbUrlCache()
  evictUnreferencedTextures({ forceAll: true })
  clearObjectMeshTextureCache()
}
